<template>
  <div class="messageBox">
    <div class="bar" :style="`z-index:${zIndex}`" @click="onCancel" />
    <div class="box fixed" :style="`z-index:${zIndex*1+500}`">
      <div class="messageTitle">
        <span class="tit">{{tit}}</span>
        <i v-if="mesShow=='30'" @click="call" class="el-icon-close"> </i>
        <span v-if="cancel" class="cancel" @click="onCancel">
          <img src="../assets/imgs/message/popup_close_normal.png" alt />
        </span>
      </div>
      <div class="messageMain">
        <template>
          <div v-html="txt" />
        </template>

        <messForm v-if="mesShow=='1' ? true : false" :ifForm="ifForm" :params="params"
                  :isCall="isCall" :tit="tit" @getMessForm="getMessForm" />
        <messUpload v-if="mesShow=='2' ? true : false" :ifForm="ifForm" :params="params"
                    :isCall="isCall" @getMessForm="getMessForm" />
        <messMemory v-if="mesShow=='3' ? true : false" :ifForm="ifForm" :params="params"
                    :projectId="projectId" :isCall="isCall" @getMessForm="getMessForm" />
        <messTeam v-if="mesShow=='20' ? true : false" :ifForm="ifForm" :params="params"
                  :isCall="isCall" :twoCodeTeam="twoCodeTeam" :wxImgUrl="wxImgUrl"
                  @getMessForm="getMessForm"></messTeam>
        <editHeadPortrait ref="edit" v-if="mesShow=='22' ? true : false" :params="params"
                          :ifForm="ifForm" :isCall="isCall" @getMessForm="getMessForm" />
        <editUserName ref="edit" v-if="mesShow=='23' ? true : false" :params="params"
                      :ifForm="ifForm" :isCall="isCall" @getMessForm="getMessForm" />
        <editPassword ref="edit" v-if="mesShow=='24' ? true : false" :params="params"
                      :ifForm="ifForm" :isCall="isCall" @getMessForm="getMessForm" />
        <editPhone ref="edit" v-if="mesShow=='25' ? true : false" :params="params" :ifForm="ifForm"
                   :isCall="isCall" @getMessForm="getMessForm" />
        <editEmail ref="edit" v-if="mesShow=='26' ? true : false" :params="params" :ifForm="ifForm"
                   :isCall="isCall" @getMessForm="getMessForm" />
        <editLanguage ref="edit" v-if="mesShow=='27' ? true : false" :params="params"
                      :ifForm="ifForm" :isCall="isCall" @getMessForm="getMessForm" />
        <editField ref="edit" v-if="mesShow=='28' ? true : false" :params="params" :ifForm="ifForm"
                   :isCall="isCall" @getMessForm="getMessForm" />
        <bindingPhone ref="edit" v-if="mesShow=='29' ? true : false" :params="params"
                      :ifForm="ifForm" :isCall="isCall" @getMessForm="getMessForm" />
        <scanCode v-if="mesShow=='30' ? true : false" :params="params" @confirm="confirm" />
        <messRate v-if="mesShow=='rate'" :rateValue="params" @getMessForm="getMessForm" />
      </div>
      <div class="but" v-if="mesShow!='30'">
        <button class="themeCallBut" @click="call">{{callBut_}}</button>
        <button class="themeGoBut" ref="ensureBtn" @click="confirm">{{confirmBut_}}</button>
      </div>
    </div>
  </div>
</template>
<script>

import messForm from "@/common/form.vue";
import messUpload from "@/common/messUpload.vue";
import messMemory from "@/common/messMemory.vue";
import messTeam from "@/common/messTeam.vue";
import editUserName from "@/common/edit/editUserName.vue";
import editPassword from "@/common/edit/editPassword.vue";
import editEmail from "@/common/edit/editEmail.vue";
import editPhone from "@/common/edit/editPhone.vue";
import bindingPhone from "@/common/edit/bindingPhone.vue";
import editField from "@/common/edit/editField.vue";
import editHeadPortrait from "@/common/edit/editHeadPortrait.vue";
import editLanguage from "@/common/edit/editLanguage.vue";
import scanCode from "@/common/edit/scanCode.vue";
import messRate from "@/common/messRate.vue";
import { async } from "q";

export default {
  name: "messageBox",
  // tit = 标题 ，txt = 主体 ，mesShow = 是否显示form表单+upload(1), 显示uoload(2)， imgSrc = title背景图, ifForm = 是否显示form表单(1为显示，0为不显示) params = 参数，传递给子级
  props: {
    tit: String,
    txt: String,
    mesShow: String,
    imgSrc: String,
    ifForm: [String, Number],
    params: [Object, Number],
    twoCode: String,
    again: [Number, String],
    projectId: [Number, String],
    isShow: [String, Boolean],
    confirmBut: {
      type: String,
      default: "确定"
    },
    callBut: {
      type: String,
      default: "取消"
    },
    cancel: {
      type: Boolean,
      define: false
    },
    zIndex: {
      type: String,
      default: "900"
    }
  },
  data () {
    return {
      fileArr: "",
      isCall: "",
      confirmBut_: this.confirmBut,
      callBut_: this.callBut,
      wxImgUrl: "",
      title: "",
      twoCodeTeam: "",
    };
  },
  components: {
    editLanguage,
    editHeadPortrait,
    editField,
    editPhone,
    bindingPhone,
    editEmail,
    editPassword,
    editUserName,
    messTeam,
    messForm,
    messUpload,
    messMemory,
    scanCode,
    messRate
  },
  created () {
    if (this.tit === "添加成员") {
      this.$privatization ? '' : this.confirmBut_ = "生成二维码";
    }
    this.twoCodeTeam = this.twoCode;
    if (this.isShow) {
      document.addEventListener("keyup", this.keyUp);
    } else {
      document.removeEventListener("keyup", this.keyUp);
    }
  },

  beforeDestroy () {
    document.removeEventListener("keyup", this.keyUp);
  },
  methods: {
    keyUp (event) {
      //确定
      if (event.keyCode === 13) {
        this.confirm();
      } else if (event.keyCode === 27) {
        this.call();
      }
      // this.$parent.del();
    },
    confirm () {
      const self = this;
      let reg = /^1\d{10}$/;

      if (self.confirmBut_ == "生成二维码") {
        var params = that.fileArr || {
          aliasName: ""
        };
        params.aliasName = params.aliasName.replace(
          /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
          ""
        );
        if (!this.detection(params.aliasName || "")) {
          return;
        }
        if (params.roleId == "") {
          that.$message({
            message: "请选择角色",
            type: "warning"
          });
          return;
        }

        if (params.loginPhone !== undefined) {
          if (!reg.test(params.loginPhone)) {
            that.$message({
              message: "请输入正确的手机号",
              type: "warning"
            });
            return;
          }

        }


        this.catReq1Service("/api/v1/companyUser/insertQrCode", params)
          .then(function (response) {
            if (response.resultCode === "1") {
              that.twoCodeTeam = true;
              that.confirmBut_ = "继续添加";
              that.callBut_ = "完成";
              that.wxImgUrl = response.result.url;
            }
          });

        return;
      } else if (self.confirmBut_ == "继续添加") {
        self.confirmBut_ = "生成二维码";
        self.callBut_ = "取消";
        self.twoCodeTeam = false;
        self.isCall++;
        return;
      }
      if (self.$refs.edit) {
        self.$refs.edit.submit(data => {
          self.$emit("message", data, self.mesShow);
        });
      } else {
        self.$emit("message", self.fileArr);
      }
    },
    // 关闭弹窗
    onCancel () {
      if (this.callBut_ === "取消" || this.callBut_ === "完成") {
        this.call()
      } else {
        this.$emit("onCancel");
      }
    },
    call () {
      this.$emit("messageIf", this.callBut_);
      this.isCall++; // 用于清空子组件数据
    },
    getMessForm (data) {
      this.fileArr = data;
    }
  }
};
</script>
<style lang="less" >
.messageBox {
  text-align: center;
  .bar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    z-index: 2500;
  }
  .box {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3000;
    opacity: 1;
    // min-width: 450px;
    // height: 290px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(76, 76, 76, 0.8);
    border-radius: 10px;
    .messageTitle {
      position: relative;
      height: 48px;
      // background: url("../assets/imgs/project/background_picture.png");
      border-radius: 10px 10px 0px 0px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      // color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 48px;
      border-bottom: 1px solid #dfe4e8;
      width: 90%;
      margin: 0 auto;
      .el-icon-close {
        float: right;
        margin-top: 12px;
        font-size: 26px;
        cursor: pointer;
      }
      .bgImg {
        width: 100%;
        height: 100%;
        border-radius: 10px 10px 0px 0px;
        // vertical-align:middle;
      }
      .tit {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
      }
      .cancel {
        position: absolute;
        right: 10px;
        img {
          cursor: pointer;
          -webkit-transition: -webkit-transform 0.6s ease-out;
          -moz-transition: -moz-transform 0.6s ease-out;
          transition: transform 0.6s ease-out;
        }
        img:hover {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          transform: rotate(180deg);
        }
      }
    }
    .messageMain {
      // width: 176px;
      // height: 180px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      // line-height: 180px;
      margin: 40px 12px;
      .languageBox {
        padding: 16px;
        // .languageLi {
        //   background: rgba(225, 238, 254, 1);
        // }
        li {
          float: left !important;
          width: 140px;
          height: 30px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(53, 53, 53, 1);
          line-height: 30px;
          border-radius: 4px;
          text-align: center;
        }
        li:hover {
          background: rgba(231, 231, 231, 1);
        }
        li:active {
          background: rgba(210, 210, 210, 1);
        }
      }
    }
    .but {
      padding-bottom: 30px;
      margin: 0 80px;
      button:nth-child(2) {
        margin-left: 30px;
      }
      button {
        width: 98px;
        padding: 0 10px;
      }
    }
  }
}
</style>